// Cadastro de armadores / agentes de carga. O processo continua gravando o NOME
// em texto (customsAgent = armador, carrier = agente de carga); este cadastro só
// alimenta os selects.
export enum ProcessPartnerType {
  Shipowner = 1,
  FreightAgent = 2,
}

export interface ProcessPartner {
  id?: string;
  name: string;
  type: ProcessPartnerType;
}

export const partnerTypeLabel: Record<ProcessPartnerType, string> = {
  [ProcessPartnerType.Shipowner]: "Armador",
  [ProcessPartnerType.FreightAgent]: "Agente de carga",
};
